import { TranslationKeys } from 'app/translations';

import { normalizeFormFieldsSchemaForGetInputOptionsAndLabelFunc } from 'app/components';

export const EmployeeSicknessLeavesFields = {
  StartDate: {
    Label: TranslationKeys.employees_detail_sickLeaveStartDate,
    InputName: 'startDate',
    Options: {
      style: 'date',
    },
  },
  EndDate: {
    Label: TranslationKeys.employees_detail_sickLeaveEndDate,
    InputName: 'endDate',
    Options: {
      style: 'date',
    },
  },
  PercentageAO: {
    Label: TranslationKeys.employees_detail_percentageAO,
    InputName: 'percentageAO',
    Options: {
      style: 'percent',
      openScale: true,
      min: 0,
      max: 100,
    },
  },
  ContractHoursWeekly: {
    Label: TranslationKeys.employees_detail_contractHoursWeekly,
    InputName: 'contractHoursWeekly',
    Options: {
      min: 0,
      openScale: true,
    },
  },
  NoRiskPolicy: {
    Label: TranslationKeys.employees_detail_noRiskPolicy,
    InputName: 'noRiskPolicy',
    Options: {
      style: 'select',
    },
  },
  SicknessPregnancyChildBirth: {
    Label: TranslationKeys.employees_detail_sicknessPregnancyChildBirth,
    InputName: 'sicknessPregnancyChildBirth',
    Options: {
      style: 'select',
    },
  },
  OrganDonated: {
    Label: TranslationKeys.employees_detail_organDonated,
    InputName: 'organDonated',
    Options: {
      style: 'select',
    },
  },
  AccidentThirdParty: {
    Label: TranslationKeys.employees_detail_accidentThirdParty,
    InputName: 'accidentThirdParty',
    Options: {
      style: 'select',
    },
  },
  NotesSickness: {
    Label: TranslationKeys.employees_detail_notesSickness,
    InputName: 'notesSickness',
    Options: {
      size: 'large',
    },
  },
  NotesRecovery: {
    Label: TranslationKeys.employees_detail_notesRecovery,
    InputName: 'notesRecovery',
    Options: {
      size: 'large',
    },
  },
} as const;

export const EmployeeEmploymentWageFieldOptionsAndLabel =
  normalizeFormFieldsSchemaForGetInputOptionsAndLabelFunc(EmployeeSicknessLeavesFields);

export type EmployeeSicknessFormValues = {
  id: string | undefined;
  [EmployeeSicknessLeavesFields.StartDate.InputName]: string | undefined;
  [EmployeeSicknessLeavesFields.EndDate.InputName]: string | undefined;
  [EmployeeSicknessLeavesFields.PercentageAO.InputName]: number | undefined;
  [EmployeeSicknessLeavesFields.ContractHoursWeekly.InputName]: number | undefined;
  [EmployeeSicknessLeavesFields.NoRiskPolicy.InputName]: string | undefined;
  [EmployeeSicknessLeavesFields.SicknessPregnancyChildBirth.InputName]: string | undefined;
  [EmployeeSicknessLeavesFields.OrganDonated.InputName]: string | undefined;
  [EmployeeSicknessLeavesFields.AccidentThirdParty.InputName]: string | undefined;
  [EmployeeSicknessLeavesFields.NotesSickness.InputName]: string | undefined;
  [EmployeeSicknessLeavesFields.NotesRecovery.InputName]: string | undefined;
};
